module.exports = __webpack_public_path__ + "static/img/award3_active.2d7845f.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/index/award3_active.png
// module id = rH6q
// module chunks = 7